// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"8391ac3d","125":"8420b8df","837":"c75eff6d"}[chunkId] + ".css";
};